/* Donut Auto Parts rebuild — theme behaviour (handoff §6/§7).
   Scope: dp- sections only. Vanilla, no deps. Reduced-motion safe.
   - Scroll-reveal fade-up (IntersectionObserver)
   - Sticky header condense + dark-flip past 40px
   - Searchable FAQ live-filter (shared Home + Product)
   Ken Burns hero zoom is pure CSS (.dp-kenburns). */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll-reveal fade-up (handoff §6 #3) */
  function initReveal() {
    if (REDUCED) return;
    var els = [].slice.call(document.querySelectorAll('.dp-section'));
    if (!els.length) return;
    var vh = window.innerHeight || 800;
    var seen = new WeakSet();

    els.forEach(function (el, i) {
      var rect = el.getBoundingClientRect();
      // First 3 sections + anything already in/above the fold: show immediately.
      if (i < 3 || rect.top < vh * 0.9) {
        el.classList.add('dp-reveal', 'dp-reveal--in');
        seen.add(el);
      } else {
        el.classList.add('dp-reveal');
      }
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dp-reveal--in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !seen.has(e.target)) {
          seen.add(e.target);
          e.target.classList.add('dp-reveal--in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -7% 0px' });

    els.forEach(function (el) { if (!seen.has(el)) io.observe(el); });

    // Failsafe: nothing stays hidden longer than 4.5s.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('dp-reveal--in'); });
    }, 4500);
  }

  /* 2. Sticky header condense + dark-flip past 40px (handoff §6 #6/#7) */
  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var condensed = false;
    var apply = function () {
      var should = (window.pageYOffset || document.documentElement.scrollTop) > 40;
      if (should !== condensed) {
        condensed = should;
        header.classList.toggle('dp-header--condensed', should);
      }
    };
    apply();
    window.addEventListener('scroll', apply, { passive: true });

    // Mobile menu: close the checkbox drawer when a nav link is tapped, so it doesn't
    // sit open over the page (e.g. covering the FAQ you just jumped to).
    var navToggle = document.getElementById('dp-nav-toggle');
    var nav = header.querySelector('.dp-header__nav');
    if (navToggle && nav) {
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) { navToggle.checked = false; }
      });
    }
  }

  /* 3. Searchable FAQ — live-filter + category chips + show-more cap (handoff v4) */
  function initFaq() {
    var CAP = 8;
    var roots = [].slice.call(document.querySelectorAll('[data-dp-faq]'));
    roots.forEach(function (root) {
      var input = root.querySelector('[data-faq-search]');
      var clear = root.querySelector('[data-faq-clear]');
      var items = [].slice.call(root.querySelectorAll('[data-faq-item]'));
      var empty = root.querySelector('[data-faq-empty]');
      var termOut = root.querySelector('[data-faq-term]');
      var chips = [].slice.call(root.querySelectorAll('[data-faq-cat-btn]'));
      var moreBtn = root.querySelector('[data-faq-more]');
      var moreLabel = moreBtn ? moreBtn.querySelector('[data-faq-more-label]') : null;
      if (!items.length) return;

      var state = { cat: 'All', expanded: false };

      var run = function () {
        var term = (input && input.value || '').trim().toLowerCase();
        var searching = !!term;

        // which items match the current filter (search spans all categories)
        var matched = items.filter(function (it) {
          if (searching) {
            var hay = (it.getAttribute('data-faq-text') || it.textContent || '').toLowerCase();
            return hay.indexOf(term) !== -1;
          }
          return state.cat === 'All' || it.getAttribute('data-faq-cat') === state.cat;
        });

        var showAll = searching || state.expanded;
        var visible = showAll ? matched : matched.slice(0, CAP);

        items.forEach(function (it) {
          var show = visible.indexOf(it) !== -1;
          it.hidden = !show;
          if (searching && show) { it.open = true; }
          else if (!searching) { it.open = false; }
        });

        if (moreBtn) {
          var hiddenCount = matched.length - visible.length;
          moreBtn.hidden = hiddenCount <= 0;
          if (moreLabel) { moreLabel.textContent = 'Show all ' + matched.length + ' questions'; }
        }
        chips.forEach(function (ch) {
          var active = !searching && ch.getAttribute('data-faq-cat-btn') === state.cat;
          ch.classList.toggle('dp-faq__chip--active', active);
        });
        if (clear) { clear.hidden = !searching; }
        if (empty) {
          var none = searching && matched.length === 0;
          empty.hidden = !none;
          if (none && termOut) { termOut.textContent = input.value.trim(); }
        }
      };

      if (input) input.addEventListener('input', function () { state.expanded = false; run(); });
      if (clear) clear.addEventListener('click', function () {
        input.value = ''; state.cat = 'All'; state.expanded = false; run(); input.focus();
      });
      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          state.cat = ch.getAttribute('data-faq-cat-btn');
          state.expanded = false;
          if (input) input.value = '';
          run();
        });
      });
      if (moreBtn) moreBtn.addEventListener('click', function () { state.expanded = true; run(); });

      run();
    });
  }

  /* 4. Maintenance splash (D-Op-6): auto on first visit, re-openable via [data-open-splash] */
  function initSplash() {
    var el = document.getElementById('dp-splash');
    if (!el) return;
    var KEY = 'dp-splash-dismissed';
    var prev = null;
    var seal = function () { try { localStorage.setItem(KEY, '1'); } catch (e) {} };

    var onKey = function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = el.querySelectorAll('a[href], button');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    function open() {
      prev = document.activeElement;
      el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var f = el.querySelectorAll('a[href], button');
      if (f.length) { f[0].focus(); }
      document.addEventListener('keydown', onKey);
    }
    function close() {
      el.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      seal();
      if (prev && prev.focus) { prev.focus(); }
    }

    var dismiss = el.querySelector('[data-splash-dismiss]');
    if (dismiss) { dismiss.addEventListener('click', close); }
    // Following a Call/eBay CTA counts as dismissing it too.
    [].slice.call(el.querySelectorAll('a[href]')).forEach(function (a) { a.addEventListener('click', seal); });
    // Manual re-open triggers (e.g. the announcement bar message).
    [].slice.call(document.querySelectorAll('[data-open-splash]')).forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    // Google Shopping bounce: when a shopper clicks a Shopping listing whose product is GONE,
    // Shopify redirects them to the HOMEPAGE with ?srsltid=... (an available product keeps them
    // on /products/<handle>?srsltid=..., so it's fine). Detect exactly that case -- srsltid AND
    // we're on the homepage -- and swap in a part-specific message instead of the generic
    // "we're rebuilding" copy. Always shown (even for repeat visitors) so it never reads as bait.
    var fromShopping = /[?&]srsltid=/.test(location.search) || /[?&]srsltid=/.test(location.hash);
    var onHome = location.pathname === '/' || location.pathname === '';
    if (fromShopping && onHome) {
      [].slice.call(el.querySelectorAll('[data-alt]')).forEach(function (n) {
        var alt = n.getAttribute('data-alt');
        if (alt) { n.textContent = alt; }
      });
      open();
      var q = el.querySelector('.dp-splash__search-input');
      if (q) { try { q.focus(); } catch (e) {} }
      return;
    }
    // First-visit auto-show removed (owner request): the maintenance splash no longer
    // interrupts visitors. It still opens for a Google Shopping bounce (srsltid, handled
    // above) and on demand via any [data-open-splash] trigger.
  }

  /* 5. Product gallery — thumbnails + prev/next + full-screen lightbox */
  function initProductGallery() {
    var gallery = document.querySelector('[data-prod-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-prod-main-img]');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-prod-thumb]'));
    var images = [];
    var dataEl = gallery.querySelector('[data-prod-images]');
    try { images = JSON.parse(dataEl.textContent) || []; } catch (e) {}
    if (!mainImg || images.length === 0) return;

    var lightbox = document.querySelector('[data-prod-lightbox]');
    var lbImg = lightbox ? lightbox.querySelector('[data-prod-lb-img]') : null;
    var lbCount = lightbox ? lightbox.querySelector('[data-prod-lb-count]') : null;
    var idx = 0;

    var show = function (i) {
      idx = (i % images.length + images.length) % images.length;
      mainImg.src = images[idx];
      if (lbImg) { lbImg.src = images[idx]; }
      if (lbCount) { lbCount.textContent = (idx + 1) + ' / ' + images.length; }
      thumbs.forEach(function (t, n) { t.classList.toggle('dp-prod__thumb--active', n === idx); });
    };

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-index'), 10) || 0); });
    });
    // prev/next live in BOTH the main image and the lightbox
    [].slice.call(document.querySelectorAll('[data-prod-prev]')).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    });
    [].slice.call(document.querySelectorAll('[data-prod-next]')).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    });

    if (lightbox) {
      var onKey = function (e) {
        if (e.key === 'Escape') { closeLb(); }
        else if (e.key === 'ArrowLeft') { show(idx - 1); }
        else if (e.key === 'ArrowRight') { show(idx + 1); }
      };
      var openLb = function () {
        show(idx);
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);
      };
      function closeLb() {
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
      }
      mainImg.addEventListener('click', openLb);
      var openBtn = gallery.querySelector('[data-prod-open]');
      if (openBtn) openBtn.addEventListener('click', openLb);
      var closeBtn = lightbox.querySelector('[data-prod-lb-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeLb);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLb(); });
    }

    show(0);
  }

  function init() {
    // Isolate each module so a throw in one can't disable the others (e.g. the gallery).
    [initReveal, initHeader, initFaq, initSplash, initProductGallery].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console && console.error) { console.error('[dp] ' + fn.name + ' failed', e); } }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init when the theme editor injects/reloads a section.
  document.addEventListener('shopify:section:load', init);
})();
